export const CLASS_NAME_SHOW = 'show'
export const CLASS_NAME_FADE = 'fade'
